import { render, staticRenderFns } from "./SiteNavigation.vue?vue&type=template&id=f2d7dc58&scoped=true&"
import script from "./SiteNavigation.vue?vue&type=script&lang=js&"
export * from "./SiteNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SiteNavigation.vue?vue&type=style&index=0&id=f2d7dc58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d7dc58",
  null
  
)

export default component.exports